exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-select.big[data-v-80135d5e] {\n  width: 440px;\n}\n.el-select.biggest[data-v-80135d5e] {\n  width: 1100px;\n}\n.el-select.countries[data-v-80135d5e] {\n  width: 440px;\n}\n.searchButton[data-v-80135d5e] {\n  margin-left: 30px;\n}\n.el-input[data-v-80135d5e] {\n  width: 200px;\n}\n.bg-purple-dark[data-v-80135d5e] {\n  background: #99a9bf;\n}\n.bg-purple[data-v-80135d5e] {\n  background: #d3dce6;\n}\n.bg-purple-light[data-v-80135d5e] {\n  background: #e5e9f2;\n}\n.el-form-item__label[data-v-80135d5e] {\n  text-align: right;\n  float: left;\n  font-size: 14px;\n  color: #606266;\n  line-height: 20px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.el-form-item[data-v-80135d5e] {\n  color: #1e0080;\n  font-weight: bold;\n  padding-right: 20px;\n  padding-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-80135d5e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/SearchUni.vue
// module id = Ae/q
// module chunks = 1